export default "__VITE_ASSET__CPOmvwSZ__"